import { useMemo } from 'react';
import * as yup from 'yup';
import { FORM_LINE_TYPES } from 'src/components/ui/FormLine/constants';

export const useFormMeeting = (params = {}) => {
	const { values } = params;

	const initialValues = useMemo(() => {
		return {
			date: null,
			time: null,
			place: '',
			...values,
		};
	}, [values]);

	const shape = useMemo(() => {
		return {
			groups: [
				{
					id: 1,
					lines: [
						{
							id: 1,
							field: {
								type: FORM_LINE_TYPES.datepicker,
								connected: true,
								params: {
									name: 'date',
									label: 'Дата встречи',
								},
							},
						},
						{
							id: 2,
							field: {
								type: FORM_LINE_TYPES.timepicker,
								connected: true,
								params: {
									name: 'time',
									label: 'Время',
								},
							},
						},
						{
							id: 3,
							field: {
								type: FORM_LINE_TYPES.textfield,
								connected: true,
								params: {
									name: 'place',
									label: 'Место',
								},
							},
						},
					],
				},
			],
		};
	}, []);

	const validationSchema = yup.object().shape({
		place: yup.string().required('Заполните место'),
		time: yup.object().required('Заполните время'),
		date: yup.object().required('Укажите дату'),
	});

	return { shape, initialValues, validationSchema };
};
